import React from 'react';
import logo from './logo.svg';

import AuthButton from '../auth/AuthButton';
import Entrance from '../pages/Entrance';
import Config from '../Config';
import Button from 'react-bootstrap/Button';
import { NavLink } from "react-router-dom";

export default class Header extends React.Component
{
  render() {
    var menuLinks = [
      {
        "text": "Main",
        "url": "/main"
      },
      {
        "text": "About",
        "url": "/about"
      },
      {
        "text": "Prices",
        "url": "/prices"
      },
      {
        "text": "Support",
        "url": "/support"
      },
      {
        "text": "Profile",
        "url": "/profile"
      },
    ]

    return (
      <div className='header'>
          <div className='logo'><img src={logo} alt={"logo"}/></div>
          <div className='navigation-container'>
            <div className='navigation'>
              {menuLinks.map((menuLink) => {
                  return (
                    <NavLink key={menuLink.text} to={Config.dirHostedAt + menuLink.url}>
                      <Button className='header-link' variant="link">{menuLink.text}</Button>
                    </NavLink>
                  );
                })}
                <div className='version'>V2.0.2</div>
            </div>
          </div>
          <div className='auth-container'>
            <AuthButton authenticationChanged={Entrance.isAuthenticated()}/>
          </div>
      </div>
    );
  }
}
